import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Params,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Config } from './../config/config.module';

@Injectable()
export class PoolsDefaultRouteGuard {
  public _config = inject(Config);
  public _router = inject(Router);

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.routeAndReturnFalse(
      '/pools/' + this._config.CONFIG.micrositeType[0].toLowerCase(),
      state.root.queryParams,
    );
  }

  private routeAndReturnFalse(route: string, queryParams: Params) {
    // Explicitly carry over this navigation's own query params (e.g. authorization_code,
    // currency, lang) rather than `queryParamsHandling: 'preserve'`/'merge': both read
    // Router.currentUrlTree.queryParams, which Angular only updates on navigation commit —
    // i.e. AFTER guards run. On the app's very first navigation (exactly the SSO-handoff
    // case this guard exists for), currentUrlTree is still the router's pristine empty
    // default, so 'preserve' silently preserved nothing. `state` is this in-flight
    // navigation's own resolved snapshot, so it has the real query params regardless of
    // timing. Confirmed via @angular/router's StateManager.commitTransition() source.
    this._router.navigate([route], { queryParams });
    return false;
  }
}
